
































import mixins from 'vue-typed-mixins';
import OversightUtils, {
  OversightOrganization,
} from '../../utils/OversightUtils';
import OversightTypePicker from './OversightTypePicker.vue';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => OversightOrganization,
    },
  },
  components: {
    OversightTypePicker,
  },
});
